module.exports = __webpack_public_path__ + "img/weal1.fe850924.png";